import React from 'react';
import DashboardStyle from './DashboardStyle';

const DashboardScreen: React.FC = () => {
  return (
    <DashboardStyle className="container">
      <p className='content-center'>DashboardScreen</p>
    </DashboardStyle>
  );
};

export default DashboardScreen;
